import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import { minifyHtmlOutput, removeDashesFromLi } from 'helpers/functions';

export const deleteHtmlFromString = (value: string) => {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.body.textContent || '';
};

export const getHtmlBody = (value: string) => {
    if (!value.includes('body')) {
        return DOMPurify.sanitize(value);
    }
    const doc = new DOMParser().parseFromString(DOMPurify.sanitize(value), 'text/html');
    return doc.body.innerHTML || '';
};

export const parseDefaultValue = (value: string) => {
    return parse(getHtmlBody(minifyHtmlOutput(value)), { trim: true });
};

export const parseStreamingValue = (value: string) => {
    return parse(getHtmlBody(removeDashesFromLi(value)), { trim: true });
};

export const parseHtmlOrNull = (value: string | null) => {
    if (value === null) {
        return null;
    }
    return parse(getHtmlBody(value), { trim: true });
};

export const extractFirstTagAndRest = (
    htmlString: string,
    tag: string,
): { tagHtml: string | null; remainingHtml: string } => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    const firstTag = doc.querySelector(tag);

    if (!firstTag) {
        return {
            tagHtml: null,
            remainingHtml: htmlString,
        };
    }

    const h2Html = firstTag.outerHTML;

    // Remove the first h2 from the original string
    const remainingHtml = htmlString.replace(h2Html, '');

    return {
        tagHtml: h2Html,
        remainingHtml: remainingHtml,
    };
};

export const sanitizeAndDeleteHtml = (value: string) => {
    return deleteHtmlFromString(DOMPurify.sanitize(value)).trim();
};
